<template>
  <div id="privatePage">
    <app-header></app-header>
    <div v-if="isAuthenticated" class="privateSection">
      <b-container fluid>
        <b-row>
          <b-col lg="2">
            <sidebar-menu></sidebar-menu>
          </b-col>
          <b-col>
            <template v-if="routerItems && routerItems.length > 1">
              <breadcrumb :items="routerItems" />
            </template>
            <router-view></router-view>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-else class="content mainSection">
      <login-block></login-block>
    </div>
    <app-message></app-message>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '../components/appheader'
import AppFooter from '../components/appfooter'
import AppMessage from '../components/appmessage'
import SidebarMenu from '../components/sidebarmenu'
import LoginBlock from '../components/users/loginblock'
import Breadcrumb from '../components/Breadcrumb/Breadcrumb'
import { mapGetters } from 'vuex'

export default {
  name: 'PrivatePage',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    routerItems() {
      var navTexts = {
        root: this.$t('publicPage.menu'),
        admin: this.$t('privatePage.menu'),
        status: this.$t('privatePage.status_header'),
        myprofile: this.$t('privatePage.my_profile_header'),
        expertreports: this.$t('privatePage.expert_report_header'),
        expertreport: this.$t('privatePage.expert_report_edit_report'),
        usergroups: this.$t('privatePage.usergroups_header'),
        group: this.$t('privatePage.usergroup_header'),
        testmethods: this.$t('privatePage.testmethods_header'),
        testmethod: this.$t('privatePage.testmethod_header'),
        scales: this.$t('privatePage.scales_header'),
        scale: this.$t('privatePage.scale_header'),
        normgroups: this.$t('privatePage.normgroups_header'),
        test: this.$t('privatePage.testmethod_header'),
        scalequestions: this.$t('privatePage.scaleQuestions_header'),
        normgroup: this.$t('privatePage.normgroup_edit_header'),
        instructions: this.$t('privatePage.instructions_header'),
        instruction: this.$t('privatePage.instruction_add_header'),
        'my-testmethods': this.$t('privatePage.my_testmethods_header'),
        testbuilder: this.$t(
          'privatePage.testbuilder_testmethods_header'
        ),
        testsuite: this.$t('privatePage.testsuite_header'),
        testdata: this.$t('privatePage.testdata_header')
      }
      var arr = this.$route.matched

      if (arr.length === 1) {
        arr = []
      } else {
        arr = arr.map(item => {
          return {
            text: navTexts[item.name],
            to: `#${item.path}`,
            isCurrent: !!(this.$route.path === item.path)
          }
        })
      }
      return arr
    }
  },
  components: {
    AppHeader,
    AppFooter,
    AppMessage,
    SidebarMenu,
    LoginBlock,
    Breadcrumb
  }
}
</script>

<style src="flag-icon-css/css/flag-icon.min.css">
</style>

<style src="font-awesome/css/font-awesome.min.css">
</style>

<style scoped>
.privateSection {
  margin-top: 30px;
}
.breadcrumb {
  background-color: white;
  margin: 0px;
  padding: 0px;
  padding-bottom: 10px;
}
</style>

<style lang="scss">
// Adjustments for the HTML-editor.

.quillWrapper {
  border: 1px solid #ccc !important;
  border-radius: 0.25rem !important;
}

.ql-toolbar.ql-snow {
  border: none !important;
  border-bottom: 1px solid #ccc !important;
}

.ql-container.ql-snow {
  border: none !important;
}

.ql-editor {
  min-height: 120px !important;
  font-size: 1rem !important;
}
</style>
